module.exports = __webpack_public_path__ + "img/SMT_50_Mr_Lum_Hon_Yuen.e3b86164.jpg";